var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettinsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99996 1C9.40109 1 9.79651 1.02971 10.1816 1.08686L10.7622 2.84569C11.2708 2.99083 11.7542 3.19768 12.2022 3.45825L13.8707 2.65369C14.4615 3.1074 14.9872 3.64224 15.4306 4.24109L14.5964 5.89478C14.8489 6.34734 15.0478 6.83419 15.1838 7.34619L16.9323 7.95532C17.0287 8.69474 17.0221 9.44394 16.9129 10.1816L15.1541 10.7621C15.0099 11.2655 14.8042 11.7492 14.5415 12.2021L15.3461 13.8707C14.8918 14.4617 14.3575 14.9867 13.7587 15.4306L12.105 14.5964C11.6476 14.8518 11.16 15.0491 10.6536 15.1838L10.0445 16.9323C9.30509 17.0287 8.5559 17.0221 7.81828 16.9129L7.23772 15.1541C6.73436 15.0099 6.25071 14.8042 5.79776 14.5415L4.12923 15.3461C3.53823 14.8917 3.01322 14.3575 2.56928 13.7587L3.40354 12.105C3.1487 11.6472 2.9514 11.1597 2.81613 10.6536L1.0676 10.0433C0.971369 9.30424 0.977907 8.55543 1.08703 7.81818L2.84584 7.23762C2.99098 6.72905 3.19783 6.24563 3.4584 5.79764L2.65385 4.12909C3.10816 3.53808 3.6424 3.01307 4.24123 2.56912L5.8949 3.40339C6.35236 3.14793 6.83993 2.9506 7.34629 2.81597L7.95656 1.06743C8.30254 1.02242 8.65107 0.999893 8.99996 1Z",
    stroke: "#444746",
    strokeWidth: 0.933,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99879 12.4283C10.8923 12.4283 12.4273 10.8933 12.4273 8.99981C12.4273 7.10629 10.8923 5.57129 8.99879 5.57129C7.10529 5.57129 5.57031 7.10629 5.57031 8.99981C5.57031 10.8933 7.10529 12.4283 8.99879 12.4283Z",
    stroke: "#444746",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettinsIcon);
export default __webpack_public_path__ + "static/media/settins-icon.c344a42701e6cea623bd3011486df486.svg";
export { ForwardRef as ReactComponent };